import { render, staticRenderFns } from "./BlogNavigation.vue?vue&type=template&id=3b518f77&scoped=true"
import script from "./BlogNavigation.vue?vue&type=script&lang=js"
export * from "./BlogNavigation.vue?vue&type=script&lang=js"
import style0 from "./BlogNavigation.vue?vue&type=style&index=0&id=3b518f77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b518f77",
  null
  
)

export default component.exports